import { colors } from 'theme/color-palette';
import { makeStyles } from '@material-ui/core/styles';
import { Bogle_Regular } from 'constants/constant';
const { WHITE, PURPLE, DARK_PURPLE, LIGHT_GREY, TOGGLE_ACTIVE } = colors;

const RBButtonStyle = makeStyles(() => ({
	root: {
		borderRadius: '50px !important',
		fontSize: '14px !important',
		height: 40,
		// border: `1px solid ${PURPLE} !important`,
		fontWeight: '600 !important',
		marginBottom: `8px !important`,
		fontFamily: `${Bogle_Regular} !important`,
		width: '100%'
	},
	primaryBtn: {
		color: `${WHITE} !important`,
		background: `${PURPLE} !important`,
		'&:hover': {
			background: `${DARK_PURPLE} !important`
		},
		'&.Mui-disabled': {
			color: `${WHITE} !important`,
			backgroundColor: `${LIGHT_GREY} !important`,
			border: 'none !important'
		}
	},
	secondryBtn: {
		color: `${PURPLE} !important`,
		background: `${WHITE} !important`,
		border: `1px solid ${LIGHT_GREY} !important`,
		'&:hover': {
			background: `${TOGGLE_ACTIVE} !important`
		},
		'&.Mui-disabled': {
			color: `${WHITE} !important`,
			backgroundColor: `${LIGHT_GREY} !important`,
			border: 'none !important'
		}
	}
}));

export default RBButtonStyle;
